import React, {Component} from 'react';
import {DataTable} from "react-data-components";
import userImage from '../../assets/128x128.jpg';
import api from '../../utils/api';
import moment from 'moment';


class TimeToRespondCounter extends Component {
    constructor(props){
        super(props);
        
        this.state = {
            counter: null,
            timerId: null,
            timerClass: ''
        }
    }
    
    componentDidMount = (props) => {
        let responseTime = this.props.settings.filter(s => s.name === "responseTime")[0];
        let counter = 0;
        if(responseTime){
            let now = moment();
            let responseBy = moment(moment(this.props.row.createdAt).add(parseInt(responseTime.value), 'hours')._d);
            counter = moment.duration(responseBy.diff(now, 'seconds') * 1000);
            // moment().diff(responseBy, 'hours')
            
            this.setState({counter: counter}, () => {
                if (!this.state.timerId) {
                    // Initiate lecture timer
                    let timer = setInterval(this.updateTimer, 1000);
    
                    this.setState({timerId: timer});
                }
            });
        }
        
    }
    
    updateTimer = () => {
        let {timerClass} = this.state;
        let responseTime = this.props.settings.filter(s => s.name === "responseTime")[0];
        let halfResponseBy = moment(moment(this.props.row.createdAt).add(parseInt(responseTime.value) / 2, 'hours')._d);
        let responseBy = moment(moment(this.props.row.createdAt).add(parseInt(responseTime.value), 'hours')._d);
        
        if(moment.duration(responseBy.diff(moment(), 'seconds') * 1000).asSeconds() < 0){
            timerClass = 'text-danger';
        }else if(moment.duration(halfResponseBy.diff(moment(), 'seconds') * 1000).asSeconds() < 0){
            timerClass = 'text-warning';
        }
            this.setState({counter: this.state.counter.subtract(1, 'seconds'), timerClass});
    }
    
    render(){
        let {counter, timerClass} = this.state;
        
        return (
            <span>{counter &&
                 <span className={timerClass}>{counter.days() + 'd ' + counter.hours() + 'h ' + counter.minutes() + 'm ' + counter.seconds() + 's'}</span>
            }
            </span>
            
        )
    }
}



class InstructorTicketView extends Component {
    
    
    renderQuestion = (val, row) => {
        let avatar = userImage;
        if(row.Profiles[0]){
            if(row.Profiles[0].image){
                if(row.Profiles[0].image.indexOf('http') > -1){
                    avatar = row.Profiles[0].image;
                }else{
                    avatar = api.makeFileURL(row.Profiles[0].image, this.props.user.id);
                }
            }
        }
        return (
            <div className="user-and-question" onClick={e => this.props.history.push('/chat/' + row.id)}>
                <div className="uq-avatar-wrap">
                    <img src={avatar} />
                </div>
                <div>
                    {row.Profiles[0] ?
                        <h3>{row.Profiles[0].name + ' ' + row.Profiles[0].lname}</h3>
                    : <h3>99Point9 User</h3>}
                    
                    <p className="task-desc-table">{row.question}</p>
                </div>
            </div>
        )
    }
    
    renderResponses = (val, row) => {
        return (
            <span>{row.Messages.length || 0}</span>
        )
    }
    
    renderCourse = (val, row) => {
        let course = null;
        this.props.courses.map(c => {
            if(c.id === row.Subject.courseId){
                course = c;
            }

        })
        return (
            <span>{(row.Subject.Course) ? row.Subject.Course.name : ''}</span>
        )
    }
    
    renderSubject = (val, row) => {
        let subject = null;
        if(this.props.course){
            this.props.course.CourseSubject.map(s => {
                if(s.id === row.subjectId){
                    subject = s;
                }
            })
        }
        if(subject){
            return (
                <span>{subject.name}</span>
            )
        }else{
            return <span></span>
        }
    }
    
    renderOpenedSince = (val, row) => {
        return (
            <span>{moment(row.createdAt).fromNow()}</span>
        )
    }
    
    renderTimeToRespond = (val, row) => {
        
        let responseTime = this.props.settings.filter(s => s.name === "responseTime")[0];
        let counter = 0;
        if(responseTime){
            let now = moment();
            let responseBy = moment(row.createdAt).add(responseTime.value, 'hours');
            counter = moment.duration(responseBy.diff(now, 'seconds') * 1000);
            // moment().diff(responseBy, 'hours')
        }
        return (
            <span>
            {!row.closed && !row.solved ?
            <TimeToRespondCounter
                row={row}
                settings={this.props.settings}
            />
            
            :
                <span>NA</span>
            }
            </span>
            
        )
    }
    
    renderStatus = (val, row) => {
        if(row.closed){
            return (
                <span className='text-warning'>DISMISSED</span>
            )
        }else{
        return (
            <span className={`${(row.solved) ? 'text-success' : 'text-info'}`}>{(row.solved) ? 'RESOLVED' : 'OPEN'}</span>
        )
        }
    }
    
    
    renderResponseTime = () => {
        let dur = 0;
        if(this.props.threads.length > 0){
            let threads = [];
            
            if(this.props.match.params.subjectId){
                threads = this.props.threads.filter(t => t.subjectId && t.ticket && t.Subject.courseId === this.props.match.params.subjectId);
            }else{
            
                threads = this.props.threads.filter(t => t.subjectId && t.ticket);
            }
            threads.map(t => {
                if(t.Messages){
                    let first = moment(t.createdAt);
                    if(t.Messages.filter(m => (m.Profile) ? m.Profile.role === 'instructor' : false).length > 0){
                        let response = moment(t.Messages.filter(m => (m.Profile) ? m.Profile.role === 'instructor' : false)[0].createdAt);
                        dur += response.diff(first, 'seconds');
                    }
                }
            })
        
          return (
            <div>
                {moment.duration(dur / threads.length).humanize()}
            </div>
            )
        }
        
      
    }
    
    render(){
        
        return (
            <div className="chat-box">
                
                        <div className="chat-head text-center">
                        <div className="flex flex-justify-content-space-between">
                        {this.props.match.params.subjectId &&
                        this.props.courses.filter(c => c.id === this.props.match.params.subjectId).length ?
                        <div>

                                <h2 className="font-22 text-white font-300 sm-bottom30"><span>{this.props.courses.filter(c => c.id === this.props.match.params.subjectId)[0].name} Tickets</span></h2>
                            
                            <div className="stacks-history">
                                <div className="stack-history-item">
                                    <span>Total Questions Asked</span><span className="text-info">{this.props.threads.filter(t => t.subjectId && t.Subject.courseId === this.props.match.params.subjectId && t.ticket).length}</span>
                                </div>
                                <div className="stack-history-item">
                                    <span>Resolved</span><span className="text-success">{this.props.threads.filter(t => t.subjectId && t.solved && t.Subject.courseId === this.props.match.params.subjectId && t.ticket).length}</span>
                                </div>
                                <div className="stack-history-item">
                                    <span>Unresolved</span><span className="text-orange">{this.props.threads.filter(t => t.subjectId && !t.solved && t.Subject.courseId === this.props.match.params.subjectId && t.ticket).length}</span>
                                </div>
                                <div className="stack-history-item">
                                    <span>Dismissed</span><span className="text-orange">{this.props.threads.filter(t => t.subjectId && t.closed && t.Subject.courseId === this.props.match.params.subjectId && t.ticket).length}</span>
                                </div>
                                <div className="stack-history-item">
                                    <span>Average Response Time</span><span className="text-info">{this.renderResponseTime()}</span>
                                </div>
                            </div>
                        </div>
                        
                        :
                        <div>

                               <h2 className="font-22 text-white font-300 sm-bottom30"><span>All Tickets</span></h2>

                            <div className="stacks-history">
                                <div className="stack-history-item">
                                    <span>Total Questions Asked</span><span className="text-info">{this.props.threads.filter(t => t.subjectId && t.ticket).length}</span>
                                </div>
                                <div className="stack-history-item">
                                    <span>Resolved</span><span className="text-success">{this.props.threads.filter(t => t.subjectId && t.solved && t.ticket).length}</span>
                                </div>
                                <div className="stack-history-item">
                                    <span>Unresolved</span><span className="text-orange">{this.props.threads.filter(t => t.subjectId && !t.solved && t.ticket).length}</span>
                                </div>
                                <div className="stack-history-item">
                                    <span>Dismissed</span><span className="text-orange">{this.props.threads.filter(t => t.subjectId && t.closed && t.ticket).length}</span>
                                </div>
                                <div className="stack-history-item">
                                    <span>Average Response Time</span><span className="text-info">{this.renderResponseTime()}</span>
                                </div>
                            </div>
                        </div>
                     }
                     </div>
                     </div>
                     <div className="chat-contents-wrapper" style={{background: '#111', paddingBottom: '50px', paddingTop: '150px'}}>
                    <div className="sp-top10" style={{paddingLeft: "20px", overflowY: "scroll", position: "relative", height: "100%", paddingRight: "20px"}}>
                    


                        <div className="tickets-table">
                                    <DataTable
                                        keys="name"
                                        className="table-striped"
                                        columns={[
                                            
                                            {title: 'Question', prop: 'question', className: 'v-middle', render: this.renderQuestion},
                                            {title: 'Responses', prop: 'status', className: 'v-middle', render: this.renderResponses},
                                            {title: 'Course', prop: 'Subject', className: 'v-middle', render: this.renderCourse},
                                            {title: 'Subject', prop: 'Subject', className: 'v-middle', render: this.renderSubject},
                                            {title: 'Opened Since', prop: 'createdAt', className: 'v-middle', render: this.renderOpenedSince},
                                            {title: 'Time to Respond', className: 'v-middle', render: this.renderTimeToRespond},
                                            {title: 'Status', prop: 'id', className: 'v-middle', render: this.renderStatus}
                                        ]}
                                        initialData={(this.props.match.params.subjectId) ? this.props.threads.filter(t => t.subjectId && t.Subject.courseId === this.props.match.params.subjectId && t.ticket) : this.props.threads.filter(t => t.subjectId && t.ticket)}
                                        useShowHideColumns={true}
                                        initialPageLength={10}
                                        initialSortBy={{ prop: 'Profiles[0].name', order: 'descending' }}
                                        pageLengthOptions={[10, 25, 50, 100]}
                                    />
                                </div>
                                    
                    </div>
                </div>
            </div>
            )
    }
}

export default InstructorTicketView;


// WEBPACK FOOTER //
// ./src/components/Chat/InstructorTicketView.js